import { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { api } from '../utils';
import axios from "axios";

const initialState = {
  success: false,
  list: [],
  loading: true
}

export default function useGetVendorList() {
  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();
  const [list, setList] = useState(initialState);

  useEffect(() => {
    api.fetchS(`Reference/GetVendorList`, {}, source.token)
      .then(
        r => {
          if (r.data.success) {
            setList({ success: true, list: r.data.vendorList, loading: false })
          } else {
            toast.error("GetSpecificationItemsWithSamples query returned an error")
          }
        })
      .catch(api.catchHandler);

    return () => {
      source.cancel("axios request cancelled");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return list;
}